import { render, staticRenderFns } from "./LgFinderPageSubgrupoProduto.vue?vue&type=template&id=7d0e919c"
import script from "./LgFinderPageSubgrupoProduto.vue?vue&type=script&lang=js"
export * from "./LgFinderPageSubgrupoProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports